import { render, staticRenderFns } from "./ProductsTableUser.vue?vue&type=template&id=7e8e62c8&scoped=true"
import script from "./ProductsTableUser.vue?vue&type=script&lang=js"
export * from "./ProductsTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e62c8",
  null
  
)

export default component.exports